
import request from "@/utils/request";

export function getAllFruitColourOptions() {
    return request({
        url: "/api/services/app/FruitColour/GetAllForDropdown",
        method: "GET"
    });
}




// WEBPACK FOOTER //
// ./src/api/fruit_colour.js